import { currencyFormat } from 'packages/common/utils/format';
import irrfResource from '../resource';

export function getLatestIrrf() {
  return irrfResource.getLatestIrrf().then(response => response.data);
}

export function getNextIrrf(id) {
  return irrfResource.getNextIrrf(id).then(response => response.data);
}

export function getPreviousIrrf(id) {
  return irrfResource.getPreviousIrrf(id).then(response => response.data);
}

export function mountViewInfo(irrf) {
  const values = [];
  values.push(mountViewObject(irrf.rend1, 'Isento', 'Isento'));
  values.push(mountViewObject(irrf.rend2, irrf.perc2, irrf.dedu2));
  values.push(mountViewObject(irrf.rend3, irrf.perc3, irrf.dedu3));
  values.push(mountViewObject(irrf.rend4, irrf.perc4, irrf.dedu4));
  values.push(mountViewObject('Maior Valor', irrf.perc5, irrf.dedu5));
  return values;
}

export function mountViewObject(incomeUpTo, aliquot, deduction) {
  return {
    incomeUpTo: formatValue(incomeUpTo),
    aliquot: formatValue(aliquot),
    deduction: formatValue(deduction),
  };
}

export function formatValue(currency) {
  return typeof currency === 'string' ? currency : currencyFormat(currency);
}
